import { defineStore } from 'pinia';
import { ref } from 'vue';

export type MobileViewMode = 'mobile' | 'desktop';

// Persisted and not reset on logout, matching the layout store (me is cleared on logout).
// On phones the persistence is effectively session-scoped: useMobileViewModeBootReset
// flips the mode back to mobile on every full page load, so a desktop choice only
// outlives a reload on tablet/desktop widths.
export const useMobilePreferenceStore = defineStore(
  'mobile-preference',
  () => {
    const preferredViewMode = ref<MobileViewMode>('mobile');

    function setPreferredViewMode(mode: MobileViewMode): void {
      preferredViewMode.value = mode;
    }

    return {
      preferredViewMode,
      setPreferredViewMode,
    };
  },
  { persist: true },
);
